import { Component, inject, OnInit } from '@angular/core';
import { heightAnimation } from '@modules/common/animations/height.animation';
import { BaseSidebarContainersItemComponent } from '@modules/common/components/base-sidebar-containers-item/base-sidebar-containers-item.component';
import { DisplayTimeZoneService } from '@modules/common/services/display-timezone.service';
import { Application } from '@modules/common/types/application';
import { SidebarSplitViewKey } from '@modules/common/types/sidebar-split-view-key';
import { SheetFolderListStateService } from '@modules/sheets/services/sheet-folder-list-state.service';
import { Sheet } from '@modules/sheets/types/sheet';
import { SheetFolder } from '@modules/sheets/types/sheet-folder';
import { SheetFoldersFilters } from '@modules/sheets/types/sheet-folders-filters';
import { VirtualFolder } from '@modules/sheets/types/virtual-folder';
import { StateKey } from '@modules/settings/types/state-key';
import { combineLatest } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-side-bar-sheet-folders',
  templateUrl: './side-bar-sheet-folders.component.html',
  styleUrls: [
    '../../../common/components/base-sidebar-containers-item/base-sidebar-containers-item.component.less',
    './side-bar-sheet-folders.component.less',
  ],
  animations: [heightAnimation],
  standalone: false,
  providers: [
    ...SheetFolderListStateService.providers({
      stateKey: StateKey.sidebarSheetFoldersListState,
    }),
  ],
})
export class SideBarSheetFoldersComponent
  extends BaseSidebarContainersItemComponent<SheetFolder, Sheet, SheetFoldersFilters, VirtualFolder>
  implements OnInit
{
  application = Application.sheets;
  sidebarSplitViewKey = SidebarSplitViewKey.sheets;

  private readonly sheetFolderListStateService = inject(SheetFolderListStateService, { self: true });
  private readonly displayTimeZoneService = inject(DisplayTimeZoneService);

  public ngOnInit() {
    super.ngOnInit();

    combineLatest([this.sheetFolderListStateService.value(), this.displayTimeZoneService.resolvedTimeZone$])
      .pipe(takeUntil(this.alive))
      .subscribe(([state, displayTimeZone]) => {
        // `displayTimeZone` FIRST: applyListState reads it to reckon its day windows in the account
        // zone (SBUX-829).
        this.filters = new SheetFoldersFilters({ displayTimeZone }).applyListState(state);
      });
  }
}
